export default "__VITE_ASSET__2OxG6QY$__"